@let link = tariffLink();
<iframe
  #iframe
  id="inlineFrameInsurance"
  title="Inline Frame insurance"
  class="w-full app-iframe"
  [src]="link ? link : sanitizedLink()"
  (load)="onLoad($event)">
</iframe>
<app-loading-spinner [loading]="loading()"/>

